import { render, staticRenderFns } from "./Sedes.vue?vue&type=template&id=09e46d96&scoped=true"
import script from "./Sedes.vue?vue&type=script&lang=js"
export * from "./Sedes.vue?vue&type=script&lang=js"
import style0 from "./Sedes.vue?vue&type=style&index=0&id=09e46d96&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e46d96",
  null
  
)

export default component.exports